import React from "react";
import Shimmer from "react-shimmer-effect"; // Use Shimmer as the default export

const BookingDetailShimmer = () => {
  return (
   
      <div className="container p-3">
        <div className="row">
          {/* Booking Title */}
          <div className="col-12 shimmer-title mb-2">
            <div className="shimmer-line" style={{ height: "50px", width: "50%", backgroundColor: "#e0e0e0" }}></div>
          </div>

          {/* User and Status */}
          <div className="col-12 d-flex justify-content-between mb-4">
            <div className="w-75 shimmer-detail">
              <div className="shimmer-line mb-2" style={{ height: "12px", width: "30%", backgroundColor: "#e0e0e0" }}></div>
              <div className="shimmer-line mb-2" style={{ height: "12px", width: "20%", backgroundColor: "#e0e0e0" }}></div>
              <div className="shimmer-line" style={{ height: "12px", width: "40%", backgroundColor: "#e0e0e0" }}></div>
            </div>
            <div className="shimmer-status">
              <div className="shimmer-line" style={{ height: "40px", width: "100px", backgroundColor: "#e0e0e0" }}></div>
            </div>
          </div>

          {/* User Info */}
          <div className="col-12 d-flex mb-4">
            <div className="w-50 shimmer-detail">
              <div className="shimmer-avatar mb-2" style={{ height: "60px", width: "60px", borderRadius: "50%", backgroundColor: "#e0e0e0" }}></div>
              <div className="shimmer-line m-2" style={{ height: "12px", width: "70%", backgroundColor: "#e0e0e0" }}></div>
              <div className="shimmer-line m-2" style={{ height: "12px", width: "70%", backgroundColor: "#e0e0e0" }}></div>
              <div className="shimmer-line m-2" style={{ height: "12px", width: "70%", backgroundColor: "#e0e0e0" }}></div>
              <div className="shimmer-line m-2" style={{ height: "12px", width: "70%", backgroundColor: "#e0e0e0" }}></div>

            </div>
            <div className="w-50 shimmer-price">
              <div className="shimmer-line mb-2" style={{ height: "12px", width: "70%", backgroundColor: "#e0e0e0" }}></div>
              <div className="shimmer-line mb-2" style={{ height: "12px", width: "70%", backgroundColor: "#e0e0e0" }}></div>
              <div className="shimmer-line mb-2" style={{ height: "12px", width: "50%", backgroundColor: "#e0e0e0" }}></div>
              <div className="shimmer-line mb-2" style={{ height: "12px", width: "50%", backgroundColor: "#e0e0e0" }}></div>
            </div>
          </div>

          {/* Terms & Conditions */}
          <div className="col-12">
            <div className="shimmer-line mb-2" style={{ height: "42px", width: "100%", backgroundColor: "#e0e0e0" }}></div>
            <div className="shimmer-line mb-2" style={{ height: "12px", width: "80%", backgroundColor: "#e0e0e0" }}></div>
            <div className="shimmer-line" style={{ height: "52px", width: "90%", backgroundColor: "#e0e0e0" }}></div>
          </div>
        </div>
      </div>
   
  );
};

export default BookingDetailShimmer;
